import { useEffect } from 'react';

import { CHART_RESIZE_DEBOUNCE_MS } from 'appConstants';
import { debounce } from 'lodash';

export const useChartResize = (chartComponent) => {
  useEffect(() => {
    const el = chartComponent?.current?.container?.current;
    const chart = chartComponent?.current?.chart;

    if (!el || !chart) return;

    const debouncedResize = debounce(() => {
      chart.reflow();
    }, CHART_RESIZE_DEBOUNCE_MS);

    const observer = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        debouncedResize();
      });
    });

    observer.observe(el);

    return () => {
      observer.disconnect();
      debouncedResize.cancel();
    };
  }, [chartComponent]);
};
